<template>
<div class="flex-grow">
<table class="table-fixed">
  <thead>
    <tr>
      <th class="w-1/6 px-4 py-2">
      </th>
      <th class="w-5/6 px-4 py-2"></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="px-4 py-2">
        <img src="/icons/pictos_CO2_1.png" class="w-auto">
      </td>
      <td class="flex px-4 py-2">
        <table class="flex-grow table-fixed">
          <thead>
            <tr class="bg-white-100 text-gray-700 font-light">
              <th class="w-3/6 px-4 py-2"></th>
              <th class="w-1/6 border-b-2 border-gray-600 font-light">Pour le projet</th>
              <th class="w-1/6 border-b-2 border-gray-600 font-light">Par m²</th>
              <th class="w-1/6 px-4 py-2"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-gray-100">
              <td class="px-4 py-2">
                  Emissions de gaz à effet de serre pour la transformation des bois
              </td>
              <td class=" px-4 py-2">{{co2Emmisions.project}}</td>
              <td class=" px-4 py-2">{{co2Emmisions.m2}}</td>
              <td class=" px-2 py-2">kg eq. CO&#8322;</td>
            </tr>
            <tr class="bg-gray-100">
              <td class=" px-4 py-2">
                    Dioxyde de carbone capté par photosynthèse
                </td>
              <td class=" px-4 py-2">{{capturedCo2Emmisions.project}}</td>
              <td class=" px-4 py-2">{{capturedCo2Emmisions.m2}}</td>
              <td class=" px-2 py-2">kg eq. CO&#8322;</td>
            </tr>
            <tr class="bg-gray-100 font-bold">
              <td class=" px-4 py-2">
                  Emissions nettes de gaz à effet de serre
                </td>
              <td class=" px-4 py-2">{{netEmmissions.project}}</td>
              <td class=" px-4 py-2">{{netEmmissions.m2}}</td>
              <td class=" px-2 py-2">kg eq. CO&#8322;</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td class="px-4 py-2">
        <img src="/icons/pictos_biogenique-2.png" class="w-auto">
      </td>
      <td class="flex px-4 py-2">
        <table class="flex-grow table-fixed">
          <thead>
            <tr class="bg-white-100 text-gray-700 font-light">
              <th class="w-3/6 px-4 py-2"></th>
              <th class="w-1/6"></th>
              <th class="w-1/6"></th>
              <th class="w-1/6 px-4 py-2"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-gray-100">
              <td class="px-4 py-2">
                  Quantité de carbone biogénique stocké dans les produits bois de votre projet
              </td>
              <td class=" px-4 py-2">{{biogenic.project}}</td>
              <td class=" px-4 py-2">{{biogenic.m2}}</td>
              <td class=" px-2 py-2">kg de carbone</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td class="px-4 py-2">
        <img src="/icons/pictos_biogenique-1.png" class="w-auto">
      </td>
      <td class="flex px-4 py-2">
        <table class="flex-grow table-fixed">
          <thead>
            <tr class="bg-white-100 text-gray-700 font-light">
              <th class="w-3/6 px-4 py-2"></th>
              <th class="w-1/6"></th>
              <th class="w-1/6"></th>
              <th class="w-1/6 px-4 py-2"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-gray-100">
              <td class="px-4 py-2">
                  Les forêts françaises stockent cette quantité de CO&#8322; en
              </td>
              <td class=" px-4 py-2">{{storedCo2.project}}</td>
              <td class=" px-4 py-2">{{storedCo2.m2}}</td>
              <td class=" px-2 py-2">seconde(s)</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td class="px-4 py-2">
        <img src="/icons/pictos_voiture.png" class="w-auto">
      </td>
      <td class="flex px-4 py-2">
        <table class="flex-grow table-fixed">
          <thead>
            <tr class="bg-white-100 text-gray-700 font-light">
              <th class="w-3/6 px-4 py-2"></th>
              <th class="w-1/6"></th>
              <th class="w-1/6"></th>
              <th class="w-1/6 px-4 py-2"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-gray-100">
              <td class="px-4 py-2">
                  Cela correspond aux émissions d'une voiture parcourant
              </td>
              <td class=" px-4 py-2">{{carEmmisions.project}}</td>
              <td class=" px-4 py-2">{{carEmmisions.m2}}</td>
              <td class=" px-2 py-2">kilomètre(s)</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td class="px-4 py-2">
        <img src="/icons/pictos_ampoule.png" class="w-auto">
      </td>
      <td class="flex px-4 py-2">
        <table class="flex-grow table-fixed">
          <thead>
            <tr class="bg-white-100 text-gray-700 font-light">
              <th class="w-3/6 px-4 py-2"></th>
              <th class="w-1/6"></th>
              <th class="w-1/6"></th>
              <th class="w-1/6 px-4 py-2"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-gray-100">
              <td class="px-4 py-2">
                  Cela correspond à la consommation électrique de
              </td>
              <td class=" px-4 py-2">{{powerConsumption.project}}</td>
              <td class=" px-4 py-2">{{powerConsumption.m2}}</td>
              <td class=" px-2 py-2">ménage(s) sur 1 mois</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>

</div>
</template>

<script>
export default {
  name: 'ResultTableEmmisionsV2',
  props: {
    co2Emmisions: { type: Object, required: true },
    biogenic: { type: Object, required: true },
    capturedCo2Emmisions: { type: Object, required: true },
    netEmmissions: { type: Object, required: true },
    storedCo2: { type: Object, required: true },
    carEmmisions: { type: Object, required: true },
    powerConsumption: { type: Object, required: true },
  },
};
</script>
